export default {
    resultadoBuscaTodasMidias: {
        filtros: {
            tipo: {
                default: null,
                data: ['Começa com', 'Contém', 'Termina com'],
                value: ''
            },
            conteudo: {
                default: null,
                label: 'Pesquisa',
                value: ''
            },
            pacienteId: {
                default: null,
                label: 'Paciente',
                value: null,
            },
        },
        paginacao: {
            page: 1,
            size: 50,
            sort: 'id',
            direction: 'DESC',
        }
    }
}